import type { HydratedAuthSession } from '@cguard/auth';

export const devVideoSession: HydratedAuthSession = {
  subject: 'dev-video-admin',
  userId: '00000000-0000-0000-0000-000000000012',
  roleNames: ['operator', 'audit-viewer', 'ssp-admin'],
  permissions: [
    { permissionKey: 'cameras.manage', requiredLoa: 1 },
    { permissionKey: 'sites.manage', requiredLoa: 1 },
  ],
  scopeGrants: [],
  authzVersion: 1,
  tier: null,
  sspId: null,
  ssuId: null,
  siteId: null,
  email: 'video.admin@cguard.local',
  displayName: 'Hospital Video Admin',
  roles: ['operator', 'audit-viewer', 'ssp-admin'],
  tenant: { tier: 'ssp' },
  cguardClaims: {
    userId: '00000000-0000-0000-0000-000000000012',
    tier: 'ssp',
    tenantChain: ['CGuard', 'Hospital Operations', 'Emergency Campus'],
  },
  accessTokenExp: Math.floor(Date.now() / 1000) + 8 * 60 * 60,
  accessToken: 'dev-video-token',
};
